import newslist from './news-list.vue';
import noResults from '../shared/no-results.vue'

new Vue({
    el: "#news",
    components: {
        newslist,
        noResults,
    },

    methods: {
        // -------------------------------- BUTTONS --------------------------------------------------
        
        shareOnFacebook() {
            var url = encodeURIComponent(window.location.href);
            var shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
            window.open(shareUrl, '_blank');
        },

        shareOnTwitter() {
            var url = encodeURIComponent(window.location.href);
            var tweetText = encodeURIComponent("Vejam este anúncio: ");
            var shareUrl = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + tweetText;
            window.open(shareUrl, '_blank');
        },
    },
})